import React from 'react';

/**
 * Accuracy Indicator Component
 * Shows icon indicating whether next run time is exact or estimated
 *
 * Props:
 * - accuracy: "Exact" or "Estimated"
 *
 * Display:
 * - Exact (Cron-scheduled): Green checkmark ✓
 * - Estimated (Timer-based): Yellow warning ⚠
 * - Includes tooltip explaining the difference
 */
const AccuracyIndicator = ({ accuracy }) => {
  const isExact = accuracy === 'Exact';

  return (
    <span
      className={`ml-2 ${isExact ? 'text-success' : 'text-warning'}`}
      title={
        isExact
          ? 'Exact: Scheduled with Cron expression'
          : 'Estimated: Based on timer interval'
      }
      style={{ cursor: 'help' }}
    >
      {isExact ? (
        <i className="fa fa-check-circle"></i>
      ) : (
        <i className="fa fa-exclamation-circle"></i>
      )}
    </span>
  );
};

export default AccuracyIndicator;
